export default __webpack_public_path__ + "static/media/glitch26.406ac85a.png";